import React, { Component } from 'react';
import MaterialIcon from 'material-icons-react';
import { allowedItemsPerPage } from '../../services/Paging';
import './PagingTableFooter.scss';

class PagingTableFooter extends Component {
    allowedNumberOfItems = allowedItemsPerPage;
    navigationActiveClassName = 'active-navigation';
    navigationInactiveClassName = 'inactive-navigation';

    pagingFunctionality() {
        let firstPageClassName,
            prevPageClassName,
            nextPageClassName,
            lastPageClassName;
        firstPageClassName = prevPageClassName =
            this.props.page > 1
                ? this.navigationActiveClassName
                : this.navigationInactiveClassName;
        nextPageClassName = lastPageClassName = this.props.hasNextPage
            ? this.navigationActiveClassName
            : this.navigationInactiveClassName;
        return this.pagingIcons(
            firstPageClassName,
            prevPageClassName,
            nextPageClassName,
            lastPageClassName
        );
    }

    testClick() {
        // console.log("Clicked!");
        // console.log(this.props.goToNextPage);
        this.props.goToNextPage();
    }
    pagingIcons(
        firstPageClassName,
        previousPageClassName,
        nextPageClassName,
        lastPageClassName
    ) {
        return (
            <span className={'paging-icons'}>
                <span
                    className={firstPageClassName}
                    onClick={() => this.props.gotToFirstPage()}
                >
                    <MaterialIcon color="inherit" icon="first_page" />
                </span>
                <span
                    className={previousPageClassName}
                    onClick={() => this.props.goToPrevPage()}
                >
                    <MaterialIcon color="inherit" icon="chevron_left" />
                </span>
                <span
                    className={nextPageClassName}
                    onClick={() => this.testClick()}
                >
                    <MaterialIcon color="inherit" icon="chevron_right" />
                </span>
                {
                    // todo: Last page navigation commented out until implemented by the backend.
                }
                {/*<span className={lastPageClassName} onClick={() => this.props.goToLastPage()}>*/}
                {/*    <MaterialIcon color="inherit" icon="last_page" />*/}
                {/*</span>*/}
            </span>
        );
    }

    allowedNumberOfItemsNumber(noOfItems) {
        return (
            <span
                key={noOfItems}
                className={'items-per-page-number'}
                onClick={() => this.props.updateNoOfItems(noOfItems)}
            >
                {noOfItems}
            </span>
        );
    }

    allowedNumberOfItemsNumberSelected(noOfItems) {
        return (
            <span key={noOfItems} className={'items-per-page-number selected'}>
                {noOfItems}
            </span>
        );
    }

    render() {
        return (
            <tr className="paging-table-footer headers">
                <td colSpan={this.props.colspan}>
                    <span className={'paging-footer-content'}>
                        <span className={'items'}>
                            <span className={'items-per-page'}>Items:</span>
                            {this.allowedNumberOfItems.map(item => {
                                if (this.props.noOfItems === item) {
                                    return this.allowedNumberOfItemsNumberSelected(
                                        item
                                    );
                                } else {
                                    return this.allowedNumberOfItemsNumber(
                                        item
                                    );
                                }
                            })}
                        </span>
                        {this.pagingFunctionality()}
                    </span>
                </td>
            </tr>
        );
    }
}

export default PagingTableFooter;
